import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-transparent p-6 plex-regular flex justify-center items-center",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_2 = {
  key: 0,
  class: "w-full max-w-md bg-transparent p-8"
}
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-red-500 mt-1 block",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_7 = { class: "bg-transparent p-8" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_9 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_10 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_11 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_12 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_13 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_14 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_16 = { class: "w-full px-2" }
const _hoisted_17 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_18 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_19 = { class: "w-full px-2" }
const _hoisted_20 = { class: "flex flex-wrap -mx-2" }
const _hoisted_21 = { class: "w-full md:w-4/12 px-2" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "w-full md:w-2/12 px-2" }
const _hoisted_28 = { class: "w-full md:w-6/12 px-2" }
const _hoisted_29 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_31 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_32 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_38 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_39 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_40 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_41 = { class: "w-full px-2" }
const _hoisted_42 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_45 = { class: "w-full px-2" }
const _hoisted_46 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_47 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_48 = { class: "w-full px-2" }
const _hoisted_49 = {
  class: "text-sm text-red-500 p-error",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_50 = { class: "flex flex-wrap py-2 mt-6 justify-between items-center" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_53 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.showFullForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "w-full pb-6 text-center" }, [
            _createElementVNode("h1", {
              class: "plex-semibold text-3xl text-gray-800 tracking-tight",
              style: {"font-family":"'Poppins', sans-serif"}
            }, " OBTENER MI PASE")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                class: "block mb-2 text-sm font-semibold text-gray-700",
                style: {"font-family":"'Poppins', sans-serif"}
              }, "DNI / Cédula de Identidad / Pasaporte", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event)),
                type: "text",
                placeholder: "DNI / Cédula de Identidad / Pasaporte",
                class: _normalizeClass(["input-base", { 'input-error': _ctx.dniError }]),
                onKeyup: _withKeys(_ctx.checkDniAndContinue, ["enter"]),
                style: {"font-family":"'Poppins', sans-serif"}
              }, null, 8, ["modelValue", "class", "onKeyup"]),
              (_ctx.dniError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.dniError), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkDniAndContinue && _ctx.checkDniAndContinue(...args))),
              class: "w-full mt-2 px-4 py-3 bg-[#ec1c24] border border-[#ec1c24] text-white hover:bg-white hover:text-[#ec1c24] font-semibold transition duration-200 flex justify-center items-center",
              disabled: _ctx.isCheckingDni,
              style: {"font-family":"'Poppins', sans-serif"}
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [
                [_vShow, _ctx.isCheckingDni]
              ]),
              _cache[16] || (_cache[16] = _createTextVNode(" CONTINUAR ", -1))
            ], 8, _hoisted_5)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema,
          class: "w-full max-w-7xl",
          onInvalidSubmit: _ctx.onInvalidSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _cache[32] || (_cache[32] = _createElementVNode("div", { class: "w-full pb-6 text-center" }, [
                _createElementVNode("h1", {
                  class: "plex-semibold text-3xl text-gray-800",
                  style: {"font-family":"'Poppins', sans-serif"}
                }, "COMPLETÁ ESTE FORMULARIO PARA OBTENER TU PASE A LA EXPO")
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "DNI / Pasaporte*", -1)),
                  _createVNode(_component_Field, {
                    name: "dni",
                    modelValue: _ctx.formData.dni,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dni) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "DNI / Pasaporte",
                        class: ["input-base", { 'bg-gray-100': true, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                        readonly: "",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_ErrorMessage, { name: "dni" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "Nombre*", -1)),
                  _createVNode(_component_Field, {
                    name: "nombre",
                    modelValue: _ctx.formData.nombre,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.nombre) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Nombre",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                        style: {"font-family":"'Poppins', sans-serif"}
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_12, [
                        _createVNode(_component_ErrorMessage, { name: "nombre" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "Apellido*", -1)),
                  _createVNode(_component_Field, {
                    name: "apellido",
                    modelValue: _ctx.formData.apellido,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.apellido) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Apellido",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                        style: {"font-family":"'Poppins', sans-serif"}
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "apellido" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "Email*", -1)),
                  _createVNode(_component_Field, {
                    name: "mail",
                    modelValue: _ctx.formData.mail,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.mail) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "email",
                        placeholder: "Email",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                        style: {"font-family":"'Poppins', sans-serif"}
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "mail" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", {
                        class: "block mb-1 font-semibold text-sm text-gray-700",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }, "País Celular*", -1)),
                      _createVNode(_component_Select, {
                        modelValue: _ctx.selectedCountryPhone,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountryPhone) = $event)),
                        filter: "",
                        options: _ctx.paises,
                        optionLabel: "descripcion",
                        placeholder: "País",
                        class: "input-base input-success",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }, {
                        value: _withCtx((slotProps) => [
                          (slotProps.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (slotProps.value.isocode)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.getFlagUrl(slotProps.value.isocode),
                                      class: "mr-2 border border-gray-200",
                                      style: {"width":"20px","height":"auto"}
                                    }, null, 8, _hoisted_23))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, _toDisplayString(slotProps.value.descripcion), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(slotProps.placeholder), 1))
                        ]),
                        option: _withCtx((slotProps) => [
                          _createElementVNode("div", _hoisted_25, [
                            (slotProps.option.isocode)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.getFlagUrl(slotProps.option.isocode),
                                  class: "mr-2 border border-gray-200",
                                  style: {"width":"20px","height":"auto"}
                                }, null, 8, _hoisted_26))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, _toDisplayString(slotProps.option.descripcion), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", {
                        class: "block mb-1 font-semibold text-sm text-gray-700",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }, "Cód.País*", -1)),
                      (_ctx.selectedCountryPhone !== null)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            type: "text",
                            modelValue: _ctx.selectedCountryPhone.id,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCountryPhone.id) = $event)),
                            class: "input-base input-success",
                            readonly: "",
                            style: {"font-family":"'Poppins', sans-serif"}
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", {
                        class: "block mb-1 font-semibold text-sm text-gray-700",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }, "Tel. Celular (con código de área)*", -1)),
                      _createVNode(_component_Field, {
                        name: "telefonoCelular",
                        modelValue: _ctx.formData.telefonoCelular,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Número (ej: 1112345678)",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                            style: {"font-family":"'Poppins', sans-serif"}
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_29, [
                            _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "País*", -1)),
                  _createVNode(_component_Field, {
                    name: "pais",
                    modelValue: _ctx.formData.pais,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.pais) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        filter: "",
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                        placeholder: "Seleccione su país",
                        options: _ctx.paises,
                        optionLabel: "descripcion",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }, {
                        value: _withCtx((slotProps) => [
                          (slotProps.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (slotProps.value.isocode)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.getFlagUrl(slotProps.value.isocode),
                                      class: "mr-2 border border-gray-200",
                                      style: {"width":"20px","height":"auto"}
                                    }, null, 8, _hoisted_33))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, _toDisplayString(slotProps.value.descripcion), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(slotProps.placeholder), 1))
                        ]),
                        option: _withCtx((slotProps) => [
                          _createElementVNode("div", _hoisted_35, [
                            (slotProps.option.isocode)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.getFlagUrl(slotProps.option.isocode),
                                  class: "mr-2 border border-gray-200",
                                  style: {"width":"20px","height":"auto"}
                                }, null, 8, _hoisted_36))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, _toDisplayString(slotProps.option.descripcion), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "pais" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "Ciudad*", -1)),
                  _createVNode(_component_Field, {
                    name: "ciudad",
                    modelValue: _ctx.formData.ciudad,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.ciudad) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Ingrese su ciudad",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                        style: {"font-family":"'Poppins', sans-serif"}
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "ciudad" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", {
                    class: "block mb-1 font-semibold text-sm text-gray-700",
                    style: {"font-family":"'Poppins', sans-serif"}
                  }, "¿Qué tipo de visitante sos?*", -1)),
                  _createVNode(_component_Field, {
                    name: "tipoVisitante",
                    modelValue: _ctx.formData.tipoVisitante,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.tipoVisitante) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                        placeholder: "Seleccione una opción",
                        options: _ctx.tipoVisitantes,
                        optionLabel: "descripcion",
                        style: {"font-family":"'Poppins', sans-serif"}
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                      _createElementVNode("span", _hoisted_42, [
                        _createVNode(_component_ErrorMessage, { name: "tipoVisitante" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              (_ctx.formData.tipoVisitante?.id === 'Profesional')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", {
                          class: "block mb-1 font-semibold text-sm text-gray-700",
                          style: {"font-family":"'Poppins', sans-serif"}
                        }, "¿Cuál describe mejor tu actividad?*", -1)),
                        _createVNode(_component_Field, {
                          name: "actividad",
                          modelValue: _ctx.formData.actividad,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.actividad) = $event))
                        }, {
                          default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                            _createVNode(_component_Select, {
                              onBlur: handleBlur,
                              "onUpdate:modelValue": handleChange,
                              "model-value": value,
                              class: _normalizeClass([{ 'bg-white': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                              placeholder: "Seleccione su actividad",
                              options: _ctx.actividades,
                              optionLabel: "descripcion",
                              style: {"font-family":"'Poppins', sans-serif"}
                            }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                            _createElementVNode("span", _hoisted_46, [
                              _createVNode(_component_ErrorMessage, { name: "actividad" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", {
                          class: "block mb-1 font-semibold text-sm text-gray-700",
                          style: {"font-family":"'Poppins', sans-serif"}
                        }, "Ingresá tu marca / empresa*", -1)),
                        _createVNode(_component_Field, {
                          name: "marcaEmpresa",
                          modelValue: _ctx.formData.marcaEmpresa,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.marcaEmpresa) = $event))
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              placeholder: "Marca / Empresa",
                              class: ["input-base", { 'bg-white': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                              style: {"font-family":"'Poppins', sans-serif"}
                            }), null, 16, ["class"]),
                            _createElementVNode("span", _hoisted_49, [
                              _createVNode(_component_ErrorMessage, { name: "marcaEmpresa" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showFullForm = false)),
                  class: "px-4 py-2 border border-gray-300 hover:border-gray-800 text-gray-600 hover:text-gray-800 rounded-lg transition duration-200 flex items-center",
                  style: {"font-family":"'Poppins', sans-serif"}
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("i", { class: "pi pi-arrow-left mr-2" }, null, -1),
                  _createTextVNode(" VOLVER ", -1)
                ]))]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "px-6 py-3 bg-[#ec1c24] border border-[#ec1c24] text-white hover:bg-white hover:text-[#ec1c24] font-semibold rounded-lg transition duration-200 flex items-center shadow-md",
                  disabled: _ctx.isSubmitting,
                  style: {"font-family":"'Poppins', sans-serif"}
                }, [
                  _withDirectives(_createElementVNode("i", _hoisted_52, null, 512), [
                    [_vShow, _ctx.isSubmitting]
                  ]),
                  _withDirectives(_createElementVNode("i", _hoisted_53, null, 512), [
                    [_vShow, !_ctx.isSubmitting]
                  ]),
                  _cache[31] || (_cache[31] = _createTextVNode(" ENVIAR MIS DATOS ", -1))
                ], 8, _hoisted_51)
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]))
  ]))
}